module.exports = __webpack_public_path__ + "static/media/201EC243.1acc1076.jpg";